/* eslint-disable max-len */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const GLOBAL_MAPS_BATTLES = (
    <FormattedMessage
        id='wgcwx_battle_schedule.title'
        defaultMessage='Бои на глобальной карте'
    />
)

export const BATTLE_SCHEDULE_INFO = (
    <FormattedMessage
        id='wgcwx_battle_schedule.info'
        defaultMessage='Количество предстоящих боёв может изменяться в зависимости от действий командного состава вашего клана и кланов-соперников на Глобальной карте.'
    />
)

export const GO_TO_GLOBAL_MAP = (
    <FormattedMessage
        id='wgcwx_battle_schedule.go_to_global_map'
        defaultMessage='Перейти к карте'
    />
)

export const AFFIRMATIVE = (
    <FormattedMessage
        id='wgcwx_battle_schedule.affirmative'
        defaultMessage='Так точно!'
    />
)



// WEBPACK FOOTER //
// ./containers/WGCWXBattleSchedule/translations.jsx